import type { CSSProperties } from "react";

type BlurTextProps = {
  text?: string;
  delay?: number;
  className?: string;
  animateBy?: "words" | "letters";
  "aria-hidden"?: boolean;
};

export function BlurText({
  text = "",
  delay = 35,
  className = "",
  animateBy = "words",
  "aria-hidden": ariaHidden
}: BlurTextProps) {
  const segments = animateBy === "words" ? text.split(" ") : text.split("");

  return (
    <p className={`blur-text flex flex-wrap ${className}`} aria-hidden={ariaHidden}>
      {segments.map((segment, index) => (
        <span
          key={`${segment}-${index}`}
          className="blur-text-segment"
          style={{ "--blur-delay": `${index * delay}ms` } as CSSProperties}
        >
          {segment === " " ? "\u00A0" : segment}
          {animateBy === "words" && index < segments.length - 1 ? "\u00A0" : null}
        </span>
      ))}
    </p>
  );
}
